import {
  APP_SCOPE_ONLINE,
  MANAGER_TYPES,
  USER_TYPES,
} from "../../UserList/utils/userConfigs";

function pushIndex(array) {
  var changed = [];
  array.map((original, index) => changed.push({ ...original, id: index + 1 }));
  return changed;
}
const reports = [
  {
    name: "Merchant raw KYC Dump",
    url: `/api/reports/v3/get-raw-merchant-kyc-data`,
    key: "get-raw-merchant-kyc-data",
    file_type: "zip",
    statusKey: "raw-merchant-kyc-data_super-admin",
    isGeneratable: true,
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
    group: "dump_files",
  },
  {
    name: "Distributor Wise Transaction Summary Report",
    url: `/api/reports/v3/dh-wise-transaction-summary-report`,
    key: "dh-wise-transaction-summary-report",
    file_type: "csv",
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
    group: "dump_files",
  },
  {
    name: "Merchant Raw Transaction Dump ",
    url: `/api/reports/v3/get-raw-merchant-trn-data`,
    key: "get-raw-merchant-trn-data",
    file_type: "zip",
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
    group: "dump_files",
  },
  {
    name: "Quiz Report",
    url: `/api/reports/v3/bquiz-report`,
    key: "bquiz-report",
    file_type: "zip",
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
    group: "campaign",
    viewReport: true,
  },
  {
    name: "Service Referral Report",
    url: `/api/reports/v3/service-referral-report`,
    key: "service-referral-report",
    file_type: "zip",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "campaign",
    viewReport: true,
  },
  {
    name: "Merchant Performance Report",
    url: `/api/reports/merchant/trn-report`,
    key: "trn-report",
    file_type: "zip",
    statusKey: "merchant-performance-report",
    filenamePatterns: ["report_type", "transaction_date"],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "merchant_performance",
    viewReport: true,
    minIOParam: "?is_minio=true",
  },
  {
    name: "Non Transacting Merchant Report",
    url: `/api/reports/v3/non-transacting-merchant-report`,
    key: "non-transacting-merchant-report",
    file_type: "zip",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "merchant_performance",
    viewReport: true,
  },
  {
    name: "Merchant App usage Report",
    url: `/api/reports/merchant/merchant-app-usage-report`,
    key: "merchant-app-usage-report",
    file_type: "zip",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "merchant_performance",
    isGeneratable: true,
    viewReport: true,
    statusKey: "merchant-app-usage-report",
  },
  {
    name: "Distributor agency report",
    url: `/api/reports/merchant/agency-report`,
    key: "agency-report",
    file_type: "zip",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "discontinued",
    viewReport: true,
  },
  {
    name: "Merchant Acquisition report",
    url: "/api/reports/merchant/detail-acquisition-report",
    key: "detail-acquisition-report",
    file_type: "zip",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "acquisition_performance",
    viewReport: true,
    statusKey: "Acquisition Report_download_at_",
    fileName: [
      {
        source: "string",
        value: "Merchant Acquisition Report",
      },
      {
        source: "form",
        value: "acquisition_report_type",
      },
      {
        source: "postbody",
        value: "start_time",
      },
      {
        source: "string",
        value: "to",
      },
      {
        source: "postbody",
        value: "end_time",
      },
    ],
  },
  {
    name: "Merchant Acquisition report - Eligible",
    url: "/api/reports/merchant/detail-eligible-acquisition-report",
    key: "detail-eligible-acquisition-report",
    file_type: "zip",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "acquisition_performance",
    viewReport: true,
    fileName: [
      {
        source: "string",
        value: "Acquisition Report Eligible",
      },
      {
        source: "form",
        value: "acquisition_report_type",
      },
      {
        source: "postbody",
        value: "start_time",
      },
      {
        source: "string",
        value: "to",
      },
      {
        source: "postbody",
        value: "end_time",
      },
    ],
  },
  {
    name: "Assisted eKYC Report",
    url: `/api/ekyc/v1/assisted-ekyc-report`,
    key: "assisted-ekyc-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "acquisition_performance",
    viewReport: true,
    statusKey: "assisted-ekyc-report",
    dateRangeLimit: 31,
    isGeneratable: true,
    fileName: [
      {
        source: "string",
        value: "Assisted eKYC Report",
      },
    ],
  },

  {
    name: "Detailed Assisted eKYC Report",
    url: `/api/ekyc/v1/assisted-ekyc-report-detailed`,
    key: "assisted-ekyc-report-detailed",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "acquisition_performance",
    viewReport: true,
    statusKey: "detailed-assisted-ekyc-report",
    dateRangeLimit: 31,
    fileName: [
      {
        source: "string",
        value: "Detailed Assisted eKYC Report",
      },
    ],
  },

  {
    name: "Merchant Lead Close Report",
    url: `/api/reports/v3/merchant-lead-close-report`,
    key: "merchant-lead-close-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "acquisition_performance",
    viewReport: true,
  },
  {
    name: "Merchant Next Followup Report",
    url: `/api/reports/v3/merchant-followup-report`,
    key: "merchant-followup-report",
    statusKey: "merchant_next_followup_report_download_at_",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "acquisition_performance",
    viewReport: true,
  },
  {
    name: "QR Binding Report",
    url: `/api/reports/v3/binding-qr-report`,
    key: "binding-qr-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "acquisition_performance",
    viewReport: true,
  },
  {
    name: "Merchant categorization file by Filter",
    url: `/api/reports/merchant/categorization-report`,
    key: "categorization-report-with-filter",
    file_type: "zip",
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
    group: "categorization",
    viewReport: true,
    isGeneratable: true,
    statusKey: "merchant-categorization-report",
  },

  {
    name: "Merchant Categorization File (Full File)",
    url: `/api/reports/merchant/categorization-report`,
    key: "categorization-report",
    file_type: "zip",
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
    isGeneratable: true,
    requestBody: { reg_start_date: "", reg_end_date: "" },
    statusKey: "merchant-categorization-report",
    group: "categorization",
  },
  {
    name: "Merchant Categorization File (LMC values added)",
    url: `/api/reports/merchant/latest-lmc-download-url`,
    key: "latest-lmc-download-url",
    file_type: "zip",
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
    group: "categorization",
    indirectDownload: true,
  },
  {
    name: "Recycle Merchant Report",
    url: `/api/reports/merchant/recycle-merchant-report`, //api/reports/merchant/recycle-merchant-report
    key: "recycle-merchant-report",
    file_type: "zip",
    group: "categorization",
    viewReport: true,
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
  },
  {
    name: "Active Employee Count",
    url: `/api/reports/v3/active-mmo-count-report`,
    key: "active-mmo-count-report",
    file_type: "csv",
    dateRangeLimit: 30,
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "discontinued",
    viewReport: true,
  },
  {
    name: "Facematching Attendance Report",
    url: `report/selfie-report`,
    module: "facematch",
    key: "download-selfie-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "attendance",
    viewReport: true,
  },
  {
    name: "Attendance Summary report",
    url: `/api/reports/v3/attendance-summary-report`,
    key: "attendance-summary-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "attendance",
    viewReport: true,
  },
  // Report Name : Territory Manager Call Report
  // Report Tab : Visit Performance
  // Report Filters : Geo/Hierarchy filters (Circle, Zone, Territory), Date Filter (Start Date, End Date)
  // View Access : Super User, Circle Head (Zone Manager), Team Lead (Area Manager)
  {
    name: "Management Survey Report",
    url: `/api/reports/v3/tm-call-report`,
    key: "tm-call-report",
    file_type: "csv",
    group: "visit_performance",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.AGENCY_USER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTION_CREDIT_MANAGER,
    ],
    viewReport: true,
  },
  {
    name: "Call Accuracy Report",
    url: `/api/reports/v3/get-lat-lng-report-merchant`,
    key: "get-lat-lng-report-merchant",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "visit_performance",
    viewReport: true,
  },
  {
    name: "Call Quality Report",
    url: `/api/reports/v3/call-quality-report`,
    key: "call-quality-report",
    file_type: "zip",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
      MANAGER_TYPES.DISTRIBUTION_CREDIT_MANAGER,
    ],
    group: "visit_performance",
    viewReport: true,
  },
  {
    name: "App Outflow Report",
    url: `/api/reports/v3/app-outflow-report`,
    key: "app-outflow-report",
    file_type: "zip",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "merchant_performance",
    viewReport: true,
    isGeneratable: true,
    statusKey: "app-outflow-report",
  },

  {
    name: "Lat Long Report",
    url: `/api/reports/v3/get-lat-lng-report`,
    key: "get-lat-lng-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "visit_performance",
    // userTypes: [USER_TYPES.BKASH_SUPER_USER],
    viewReport: true,
  },
  {
    name: "Day wise MMO Visit Report",
    url: `/api/reports/v3/mmo-visit-report`,
    key: "mmo-visit-report",
    file_type: "csv",
    dateRangeLimit: 30,
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "visit_performance",
    viewReport: true,
  },
  {
    name: "Territory Summary Report",
    url: `/api/reports/v3/territory-summery-report`,
    key: "territory-summery-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "visit_performance",
    viewReport: true,
  },
  {
    name: "MMO Call Summery Report",
    url: `/api/reports/v3/mmo-call-summery-report`,
    key: "mmo-call-summery-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "visit_performance",
    viewReport: true,
  },
  {
    name: "Detailed Merchant Survey Data",
    url: `/api/reports/v1/raw-data-report`,
    key: "raw-data-report",
    file_type: "zip",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "visit_performance",
    statusKey: "raw-data-report",
    isGeneratable: true,
  },

  {
    name: "Daily MMO Performance Report",
    url: `/api/reports/v3/daily-mmo-performance-report`,
    key: "daily-mmo-performance-report",
    file_type: "csv",
    dateRangeLimit: 30,
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "visit_performance",
    viewReport: true,
  },
  {
    name: "POSM Call",
    url: `/api/reports/v2/merchant-call-report`,
    key: "merchant-call-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "visit_performance",
    viewReport: true,
  },
  {
    name: "Unique Regular Visit Report",
    url: `/api/reports/v1/unique-visit-summary-report`,
    key: "unique-visit-summary-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "visit_performance",
    viewReport: true,
  },
  {
    name: "Route Call Report",
    url: `/api/reports/v3/route-call-report`,
    key: "route-call-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "visit_performance",
    viewReport: true,
  },
  {
    name: "Cumulative Merchant Unique Visit Report",
    url: `/api/reports/v1/cumulative-merchant-unique-visit-summary-report`,
    key: "cumulative-merchant-unique-visit-summary-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "visit_performance",
    viewReport: true,
  },
  {
    name: "Merchant Banking Inclusion Call Report",
    url: `/api/reports/v3/merchant-bank-inclusion-report`,
    key: "merchant-bank-inclusion-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "visit_performance",
    viewReport: true,
  },
  {
    name: "Not Visited Merchant List Report",
    url: `/api/reports/v1/not-visited-merchant-list-report`,
    key: "not-visited-merchant-list-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "discontinued",
    viewReport: true,
  },
  {
    name: "MDO Average Performance Report",
    url: `/api/reports/v3/agency-wise-report`,
    key: "agency-wise-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "discontinued",
    viewReport: true,
  },
  {
    name: "MDO Performance Report",
    url: `/api/reports/v1/mdo-wise-report`,
    key: "mdo-wise-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "discontinued",
    viewReport: true,
  },
  {
    name: "Employee to Supervisor Mapping",
    url: `/api/reports/v3/employee-supervisor-mapping`,
    key: "employee-supervisor-mapping",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "mapping",
    viewReport: true,
  },
  {
    name: "Merchant Tag Report",
    url: `/api/reports/merchant/merchant-tag-report`,
    key: "merchant-tag-report",
    file_type: "zip",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "mapping",
    viewReport: true,
  },
  {
    name: "Employee List",
    url: `/api/reports/v3/mdo-information-report`,
    key: "mdo-information-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "mapping",
    viewReport: true,
  },
  {
    name: "Spot List",
    url: `/api/reports/v3/spot-info-report`,
    key: "spot-info-report",
    statusKey: "spot_info_report_download_at_",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "mapping",
    viewReport: true,
  },
  {
    name: "Spot Mapping Report",
    url: `/api/reports/v3/spot-mapping-report`,
    key: "spot-mapping-report",
    statusKey: "spot_mapping_report_download_at_",
    file_type: "zip",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "mapping",
    viewReport: true,
  },
  {
    name: "Outlet - Route Mapping List",
    url: `/api/reports/v3/merchant-list-report`,
    key: "merchant-list-report",
    statusKey: "merchant_report_report_download_at_",
    file_type: "zip",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "mapping",
    viewReport: true,
  },
  {
    name: "Assigned Route Report",
    url: `/api/reports/v3/assigned-route-report`,
    key: "assigned-route-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "mapping",
    viewReport: true,
  },
  {
    name: "Acquisition Target vs Achievement Report",
    url: `/api/reports/v3/acquisition-target-vs-achivement`,
    key: "acquisition-target-vs-achivement",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "target_vs_achievement",
    viewReport: true,
  },
  {
    name: "Distributor Target vs Achievement Report",
    url: `/api/reports/v3/distributor-target-vs-achievement`,
    key: "distributor-target-vs-achievement",
    file_type: "xlsx",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "target_vs_achievement",
    viewReport: true,
  },
  {
    name: "Route Target vs Achievement Report",
    url: `/api/reports/v3/route-target-vs-achievement`,
    key: "route-target-vs-achievement",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "target_vs_achievement",
    viewReport: true,
  },
  {
    name: "Device Availability Report",
    url: "/api/payment_speaker/v1/device-report", //`/api/reports/v3/route-target-vs-achievement`,
    key: "device-availability-report",
    file_type: "csv",
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
    group: "inventory",
    viewReport: false,
    action: { title: "Sync", url: "/api/payment_speaker/v1/sync-device" },
  },
  {
    name: "Payment Speaker Binding Status Report",
    url: "/api/payment_speaker/v1/payment-speaker-binding-status-report", //`/api/reports/v3/route-target-vs-achievement`,
    key: "payment-speaker-binding-status-report",
    file_type: "csv",
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
    group: "inventory",
    viewReport: true,
  },
  {
    name: "Payment Speaker Device Location Report",
    url: "/api/payment_speaker/v1/payment-speaker-device-location-report", //`/api/reports/v3/route-target-vs-achievement`,
    key: "payment-speaker-device-location-report",
    file_type: "csv",
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
    group: "inventory",
    viewReport: true,
  },
  {
    name: "Route Performance Report",
    url: `/api/reports/v3/route-performance-report`,
    key: "route-performance-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "discontinued",
    viewReport: true,
  },
  {
    name: "Online Lead Report",
    url: `/api/online/v1/generate-lead-report`, //api/online/v1/generate-lead-report
    key: "generate-lead-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "discontinued",
    scopes: [APP_SCOPE_ONLINE],
    viewReport: true,
  },
  {
    name: "Online Call Report",
    url: `/api/online/v1/generate-call-report`, //api/online/v1/generate-lead-report
    key: "generate-call-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "discontinued",
    scopes: [APP_SCOPE_ONLINE],
    viewReport: true,
  },
  {
    name: "Online MAO Performance Report",
    url: `/api/online/v1/generate-mao-performance-report`, //api/online/v1/generate-lead-report
    key: "generate-mao-performance-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "discontinued",
    scopes: [APP_SCOPE_ONLINE],
    viewReport: true,
  },
  {
    name: "Online Email History Report",
    url: `/api/online/v1/email-history-report`, //api/online/v1/generate-lead-report
    key: "email-history-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "discontinued",
    scopes: [APP_SCOPE_ONLINE],
    viewReport: true,
  },
  {
    name: "Assisted eKYC Report (Online)",
    url: `/api/ekyc/v1/assisted-ekyc-report`,
    key: "assisted-ekyc-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "acquisition_performance",
    scopes: [APP_SCOPE_ONLINE],
    viewReport: true,
    statusKey: "assisted-ekyc-report",
    isGeneratable: true,
  },
  {
    name: "Lead Call Quality Report",
    url: "/api/acquisition-calls/v1/call-quality-report",
    key: "acquisition-call-quality-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "acquisition_performance",
    viewReport: true,
  },
  {
    name: "Lead Pipeline Report",
    url: "/api/acquisition-calls/v1/lead-pipeline-report",
    key: "lead-pipeline-report",
    file_type: "csv",
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "acquisition_performance",
    viewReport: true,
  },
  {
    name: "Merchant Eligibility And Rollout",
    url: `/api/payment_speaker/v1/merchant-eligibility-and-rollout`,
    key: "merchant-eligibility-and-rollout",
    file_type: "csv",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.AGENCY_USER,
      // "warehouse_manager",
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "payment_speaker",
    viewReport: true,
  },
  {
    name: "Pricing Plans Details",
    url: `/api/payment_speaker/v1/pricing-plans-details`,
    key: "pricing-plans-details",
    file_type: "csv",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.AGENCY_USER,
      // "warehouse_manager",
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "payment_speaker",
    viewReport: true,
  },
  {
    name: "Device Binding Unbinding Report",
    url: `/api/payment_speaker/v1/device-binding-unbinding`,
    key: "device-binding-unbinding",
    file_type: "csv",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.AGENCY_USER,
      // "warehouse_manager",
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "payment_speaker",
    viewReport: true,
  },
  {
    name: "PSB Tracking Report",
    url: `/api/payment_speaker/v1/inventory-tracking`,
    key: "inventory-tracking",
    file_type: "csv",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.AGENCY_USER,
      USER_TYPES.WAREHOUSE_MANAGER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
    ],
    group: "payment_speaker",
    viewReport: true,
  },
  {
    name: "QC Execution Log Report",
    url: `/api/reports/v3/qc-execution-log-report`,
    key: "qc-execution-log-report",
    file_type: "csv",
    userTypes: [USER_TYPES.CS_SUPER_USER],
    group: "bank_inclusion",
    viewReport: true,
  },
  {
    name: "QC Performance Report",
    url: `/api/reports/v3/qc-performance-report`,
    key: "qc-performance-report",
    file_type: "csv",
    userTypes: [USER_TYPES.CS_SUPER_USER],
    group: "bank_inclusion",
    viewReport: true,
    dateRangeLimit: 60,
  },
  {
    name: "Merchant Loan Comprehensive Report",
    url: `/api/merchant-loan/v1/comprehensive-report`,
    key: "comprehensive-report",
    file_type: "csv",
    userTypes: [
      USER_TYPES.BKASH_SUPER_USER,
      USER_TYPES.CIRCLE_HEAD,
      USER_TYPES.AREA_MANAGER,
      USER_TYPES.REGIONAL_MANAGER,
      USER_TYPES.TERRITORY_MANAGER,
      USER_TYPES.AGENCY_USER,
    ],
    managerTypes: [
      MANAGER_TYPES.MDE,
      MANAGER_TYPES.MDM,
      MANAGER_TYPES.MAM,
      MANAGER_TYPES.MMM,
      MANAGER_TYPES.DISTRIBUTOR,
      MANAGER_TYPES.OPERATION_MANAGER,
      MANAGER_TYPES.DISTRIBUTION_CREDIT_MANAGER,
    ],
    group: "merchant_loan",
    viewReport: true,
  },
  {
    name: "Merchant Loan Dump Report",
    url: `/api/merchant-loan/v1/dump-report`,
    key: "dump-report",
    file_type: "csv",
    userTypes: [USER_TYPES.BKASH_SUPER_USER],
    isGeneratable: true,
    statusKey: "dump-report",
    group: "merchant_loan",
    fileName: [
      {
        source: "string",
        value: "Merchant Loan Dump Report",
      },
      {
        source: "postbody",
        value: "dump_report_type",
      },
      {
        source: "postbody",
        value: "date",
      },
    ],
  },
];
const reportsList = pushIndex(reports);
export { reportsList };
